export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Searh campaign participation record": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["캠페인 참여 기록 검색"])},
      "page desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["최근 3년간의 참여 기록을 확인할 수 있습니다."])},
      "No collection history record": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["참여 신청 내역이 없습니다"])}
    }
  })
}
